import React, { Children } from "react"
import PropTypes from 'prop-types';

import { arrayToObject } from 'common';

class Config {
  constructor(props) {
    this.systemScopes = [];
    this.whitelists = [];
    this.features = [];
  }

  addSystemScopes(scopes) {
    this.systemScopes = arrayToObject(scopes, 'value');
  }

  spreadSystemScopes(scopes) {
    return scopes.map(i => this.systemScopes[i] != null ? this.systemScopes[i] : {value: i, icon: ''});
  }

  whitelistByClient(obj) {
    return this.whitelists.find(i => i.clientId === obj.clientId);
  }
};


export class ConfigProvider extends React.Component {
  static propTypes = { scopes: PropTypes.array }
  static childContextTypes = { config: PropTypes.object.isRequired }

  config = new Config();


  componentWillReceiveProps(props) {
    this.config.addSystemScopes(props.scopes||[]);
    this.config.whitelists = props.whitelists;
    this.config.features = props.features;
    this.config.forceUpdate = this.forceUpdate;
  }

  getChildContext() {
    const config = this.config;
    return { config };
  }

  forceUpdate = () => {
    const { onChange } = this.props;

    onChange && onChange();
  }

  render() {
    return this.props.children;
  }
};

export const withConfig = (ChildComponent) => {
  const Wrapper = (props, {config}) =>
    (<ChildComponent config={config} {...props} />);

  Wrapper.contextTypes = {config: PropTypes.object.isRequired};

  return Wrapper;
};
